module.exports = __webpack_public_path__ + "img/done.63021116.png";